import modernizr from './modernizr';
import '../css/style.scss';
import './compatibily';